// What the container tells the page at start: `/config.js` sets it from the
// container's environment, so one image serves staging and production.
export type RuntimeConfig = { apiUrl?: string }

declare global {
	interface Window {
		__TEZGO_CONFIG__?: RuntimeConfig
	}
}

export function resolveApiUrl(
	config: RuntimeConfig | undefined,
	env: { PROD: boolean; VITE_API_URL?: string }
): string {
	const apiUrl = config?.apiUrl || env.VITE_API_URL
	if (apiUrl) return apiUrl
	if (env.PROD) {
		throw new Error(
			'API_URL is not configured: /config.js did not set window.__TEZGO_CONFIG__.apiUrl'
		)
	}
	return 'http://localhost:7778'
}
